import { Component, input, model, OnChanges, OnInit, output, SimpleChanges } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { NgbDateStruct, NgbInputDatepicker } from '@ng-bootstrap/ng-bootstrap'
import { MatIcon } from '@angular/material/icon'
import { dateOnlyFormat } from '../shared/utilities/date'
import { TZDate } from '@date-fns/tz'
import { EntityFieldComponent } from './entity-field.component'

type ModelType = NgbDateStruct | undefined

const parseDateStruct = (rawValue: string | undefined): ModelType => {
  if (rawValue) {
    const tzDate = new TZDate(rawValue, 'EST')
    return {
      year: tzDate.getFullYear(),
      month: 1 + tzDate.getMonth(),
      day: tzDate.getDate(),
    }
  } else {
    return undefined
  }
}

const toISO = (modelValue: ModelType): string | undefined => {
  if (modelValue) {
    const valueOf = new TZDate(modelValue.year, modelValue.month - 1, modelValue.day, 'EST').getTime()
    return new Date(valueOf).toJSON()
  } else {
    return undefined
  }
}

@Component({
  selector: 'app-entity-date-field',
  imports: [
    FormsModule,
    MatIcon,
    NgbInputDatepicker,
    EntityFieldComponent,
  ],
  template: `
    <div
        app-entity-field
        [id]="id()"
        [label]="label()"
        [validationMessage]="validationMessage()"
    >
      <div class='input-group'>
        <input ngbDatepicker
            class="form-control"
            [placeholder]="dateOnlyFormat"
            [(ngModel)]="model"
            #d="ngbDatepicker"
        />
        <button (click)="d.toggle()" class='btn btn-outline-secondary'>
          <mat-icon fontIcon="calendar_month"></mat-icon>
        </button>
      </div>
    </div>
  `,
  styles: `
    input {
      margin-top: 0;
    }
    .btn {
      border-radius: 0 6px 6px 0;
      padding: 5px 3px 0 3px;
      border-color: #c6c6c6;
    }
  `,
})
export class EntityDateFieldComponent implements OnInit, OnChanges {
  readonly id = input.required<string>()
  readonly label = input.required<string>()
  readonly value = input.required<string | undefined>()
  readonly validationMessage = input<string>()
  readonly valueChange = output<string | undefined>()
  protected readonly dateOnlyFormat = dateOnlyFormat

  protected readonly model = model<ModelType>()

  ngOnInit() {
    this.model.subscribe(value => {
      const newValue = toISO(value)
      if (this.value() !== newValue) {
        this.valueChange.emit(newValue)
      }
    })
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['value']) {
      this.updateModel()
    }
  }

  private updateModel() {
    this.model.set(parseDateStruct(this.value()))
  }
}
